module.exports = __webpack_public_path__ + "static/media/praying-hands.9c5f1e60.svg";